import React from 'react';
import { Circle, G, Line, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { CoilSymbol } from '../primitives/CoilSymbol';
import { DT } from '../tokens';

/** Q_t = 4.5·CFM·Δh — total enthalpy change across coil. */
export function DiagramTotalHeat() {
  const dy = 100, dh = 65;
  const cy = dy + dh / 2;

  return (
    <DiagramCanvas>
      {/* Entering — warm/humid (orange + droplets) */}
      <Rect x={20} y={dy} width={70} height={dh} fill="rgba(255,107,26,0.18)" stroke={DT.stroke} strokeWidth="1.5" />
      <Line x1={28} y1={cy} x2={84} y2={cy} stroke={DT.arrow} strokeWidth="1.6" />
      <Polygon points={`86,${cy} 80,${cy - 4} 80,${cy + 4}`} fill={DT.arrow} />
      {[35, 50, 70, 42, 60].map((px, i) => (
        <Circle key={i} cx={px} cy={dy + 12 + (i * 8) % (dh - 24)} r={1.4} fill="#7AAABB" opacity={0.7} />
      ))}

      {/* Coil */}
      <CoilSymbol x={90} y={dy} width={150} height={dh} loops={5} />

      {/* Leaving — cool/dry */}
      <Rect x={240} y={dy} width={80} height={dh} fill="rgba(122,170,187,0.18)" stroke={DT.stroke} strokeWidth="1.5" />
      <Line x1={248} y1={cy} x2={310} y2={cy} stroke={DT.arrow} strokeWidth="1.6" />
      <Polygon points={`312,${cy} 306,${cy - 4} 306,${cy + 4}`} fill={DT.arrow} />

      {/* Enthalpy badges */}
      <Rect x={26} y={dy - 22} width={56} height={14} fill="rgba(230,180,140,0.85)" rx="2" />
      <SvgText x={54} y={dy - 12} fill="#0D1B2A" fontSize="8.5" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">h₁ (BTU/lb)</SvgText>
      <Rect x={252} y={dy - 22} width={56} height={14} fill="rgba(122,170,187,0.85)" rx="2" />
      <SvgText x={280} y={dy - 12} fill="#0D1B2A" fontSize="8.5" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">h₂ (BTU/lb)</SvgText>

      {/* Δh brace */}
      <Line x1={54} y1={dy - 38} x2={280} y2={dy - 38} stroke={DT.varColor} strokeWidth="1" />
      <Polygon points={`54,${dy - 38} 60,${dy - 35} 60,${dy - 41}`} fill={DT.varColor} />
      <Polygon points={`280,${dy - 38} 274,${dy - 35} 274,${dy - 41}`} fill={DT.varColor} />
      <SvgText x={167} y={dy - 42} fill={DT.varColor} fontSize="10" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">Δh = h₁ − h₂</SvgText>

      {/* Q_s + Q_l = Q_t reminder */}
      <Rect x={100} y={dy + dh + 8} width={130} height={18} fill="rgba(0,0,0,0.4)" stroke={DT.varColor} strokeWidth="0.8" />
      <SvgText x={165} y={dy + dh + 21} fill={DT.varColor} fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">Q_t = Q_s + Q_l</SvgText>

      {/* Labels */}
      <LeaderLine x1={55} y1={cy} x2={20} y2={210} varName="CFM" desc="airflow" anchor="start" />
      <LeaderLine x1={167} y1={dy + dh - 8} x2={167} y2={210} varName="Q_t" desc="total BTU/h" anchor="middle" />
      <LeaderLine x1={280} y1={cy} x2={310} y2={210} varName="Δh" desc="enthalpy drop" anchor="end" />

      <FormulaTag formula="Q_t = 4.5 · CFM · Δh   (sensible + latent)" />
    </DiagramCanvas>
  );
}
